export enum BulkImportStatusType {
  New = 'New',
  Running = 'Running',
  Cancelled = 'Cancelled',
  Finished = 'Finished',
  Failed = 'Failed',
}
